import { Component, OnDestroy, OnInit, SimpleChanges, ViewContainerRef } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { Subject } from 'rxjs/Subject';
import { distinctUntilChanged, filter, first, map, pairwise, startWith, takeUntil, withLatestFrom } from 'rxjs/operators';
import { AlgOtpModalComponent } from '../../components/dialogs/alg-otp-modal/alg-otp-modal.component';

import 'moment/locale/it';

import { LocationStrategy } from '@angular/common';
import { AfterContentChecked, ChangeDetectorRef } from '@angular/core';
import { FileUploader } from 'ng2-file-upload/ng2-file-upload';
import { ModalDialogService } from 'ngx-modal-dialog';
import { environment } from '../../../environments/environment';
import { AlgConditionModalComponent } from '../../components/dialogs/alg-condition-modal/alg-condition-modal.component';
import { ProductType, VulnerabilityType } from '../../models/product';
import { AlgAttivazioniService } from '../../services/alg-attivazioni.service';
import {
  AlgConsensoService,
  APPROVAL_STATUS_COMPLETED,
  APPROVAL_STATUS_ERROR,
  APPROVAL_STATUS_INVALID,
  APPROVAL_STATUS_OK,
  APPROVAL_STATUS_SIGNED,
} from '../../services/alg-consenso.service';
import { Approval, ApprovalConsents, ApprovalFeedback } from '../../services/alg-consenso.service.d';
import { ApiService } from '../../services/api.service';
import { UtilsService } from '../../services/utils.service';

@Component({
  selector: 'alg-consenso',
  templateUrl: './alg-consenso.component.html',
  styleUrls: ['./alg-consenso.component.scss'],
})
export class AlgConsensoComponent implements OnInit, OnDestroy, AfterContentChecked {
  public isLoading$: Observable<boolean>;
  public isApprovalOk$: Observable<boolean>;
  public isApprovalCompleted$: Observable<boolean>;
  public isErrorAlreadySigned$: Observable<boolean>;
  public isErrorInvalidOffer$: Observable<boolean>;
  public isErrorGeneric$: Observable<boolean>;
  public productType$: Observable<string>;
  public operatorRating$: Observable<ApprovalFeedback>;
  public isConsentsOk: boolean;
  public feedbackOptions = [
    { image: 'bad', value: 100 },
    { image: 'normal', value: 200 },
    { image: 'good', value: 300 },
    { image: 'excellent', value: 400 },
  ];
  public feedbackModalContent = {
    title: 'La tua privacy per noi è importante.',
    description: '',
  };
  public allSteps: any = [];
  public currentStepFound = { status: false, number: 0 };
  public onbProgressConfig = {
    options: { stepNumber: 1, title: 'Opzioni sicure' },
    consenso: { stepNumber: 2, title: 'Consensi' },
  };
  public stepsName = Object.keys(this.onbProgressConfig);
  public currentStepStatus = 'consenso';
  public firstStep = false;
  public product: any;
  public isLight: boolean;
  public isGas: boolean;
  public overDropFront: boolean;
  public overDropBack: boolean;
  public uploaderFront: FileUploader;
  public uploaderBack: FileUploader;
  public istanzaUploader1: FileUploader;
  public istanzaUploader2: FileUploader;
  public istanzaUploader3: FileUploader;
  public istanzaUploader4: FileUploader;
  public idCardUploader1: FileUploader;
  public idCardUploader2: FileUploader;
  public showProgress1: boolean;
  public showProgress2: boolean;
  public showProgress3: boolean;
  public showProgress4: boolean;
  public showProgress5: boolean;
  public showProgress6: boolean;
  public secondIstanza: boolean;
  public idCardSecondIstanza: boolean;
  public uploadedDocumentFront: boolean;
  public uploadedDocumentBack: boolean;
  public documentUploadedFront: string;
  public documentUploadedBack: string;
  public fileFormatErrorFront: boolean;
  public fileFormatErrorBack: boolean;
  public isProductGasVulnerable: boolean;
  public isProductPlacet: boolean;
  public isProductGasVulnerableSecondStep: boolean;
  public loadingPdf = false;
  public downloadedPDF = false;
  public vulnerabilityCheckboxes = false;
  public folderUrl = '';
  public optionGasValue = false;
  public optionLightValue = false;
  public goNextStep = false;
  public productFamily: string;
  // KEYSTONE VALUE INFORMATIVE THAT HAS BEEN READED
  public informativeGasBeenReaded = false;
  public informativeLightBeenReaded = false;

  public isLinearGasOn: boolean;
  public isLinearLightOn: boolean;

  public consentsWithAdditionalProperty: any;

  public checkboxGasContainer = {
    checkboxGasDeclare: false,
    checkboxGasInformative: false,
  };

  public checkboxLightContainer = {
    checkboxLightDeclare: false,
    checkboxLightInformative: false,
  };

  public checkboxGeneralCondition = {
    checkboxConsents: false,
    checkboxClause: false,
  };

  // GENERAL PRIVACY CHECKBOX
  public checkboxPersonalData: boolean;
  public personalDataIsValid: boolean;

  // CLAUSE CONDITION CHECKBOXES
  public checkboxConsentCondition: boolean;
  public generalConditionIsValid: boolean;
  public checkboxClauseCondition: boolean;
  public clauseConditionIsValid: boolean;

  public controlGasDeclare: boolean;
  public controlGasInformative: boolean;
  public controlLightDeclare: boolean;
  public controlLightInformative: boolean;

  private opportunityId$: Observable<any>;
  private opportunityId: string;
  private approvalId: string;
  private approval: Approval;
  private phone_number: string;
  private consents: ApprovalConsents;
  private ngUnsubscribe = new Subject<void>();
  public vulnerabilityType: VulnerabilityType;
  public vulnerabilityAcceptance = {
    socialBonus: false,
    disability: false,
    housingEmergency: false,
  };
  private vulnerabilityTypeUserSelected: VulnerabilityType;

  public needsPreConsent: boolean = true;

  constructor(
    private activatedRoute: ActivatedRoute,
    private consensoService: AlgConsensoService,
    private utils: UtilsService,
    private modalDialogService: ModalDialogService,
    private viewContainer: ViewContainerRef,
    public locations: LocationStrategy,
    private changeDetector: ChangeDetectorRef,
    private api: AlgAttivazioniService,
    private apiService: ApiService
  ) {
    this.opportunityId$ = this.activatedRoute.params.pipe(map((params) => params && params.id));
    this.isLoading$ = this.consensoService.isLoading$;
    this.isApprovalOk$ = this.consensoService.approvalStatus$.pipe(
      map((status) => status === APPROVAL_STATUS_OK),
      startWith(false),
      distinctUntilChanged()
    );
    this.isApprovalCompleted$ = this.consensoService.approvalStatus$.pipe(
      map((status) => status === APPROVAL_STATUS_COMPLETED),
      startWith(false),
      distinctUntilChanged()
    );
    this.isErrorAlreadySigned$ = this.consensoService.approvalStatus$.pipe(
      map((status) => status === APPROVAL_STATUS_SIGNED),
      startWith(false),
      distinctUntilChanged()
    );
    this.isErrorInvalidOffer$ = this.consensoService.approvalStatus$.pipe(
      map((status) => status === APPROVAL_STATUS_INVALID),
      startWith(false),
      distinctUntilChanged()
    );
    this.isErrorGeneric$ = this.consensoService.approvalStatus$.pipe(
      map((status) => status === APPROVAL_STATUS_ERROR),
      startWith(false),
      distinctUntilChanged()
    );
    this.productType$ = this.consensoService.approvalProduct$.pipe(map((product) => !!product && product.type));
    this.operatorRating$ = this.consensoService.operatorRatingCode$.pipe(first((rating) => !!rating));

    // SUBCRIBES where we have a view & control of fields validity and checkbox
    this.consensoService.gasLinearSubject$.subscribe((item) => {
      this.controlGasDeclare = !item;
    });
    this.consensoService.gasLinearInformative$.subscribe((item) => {
      this.controlGasInformative = !item;
    });
    this.consensoService.lightLinearSubject$.subscribe((item) => {
      this.controlLightDeclare = item;
    });
    this.consensoService.lightLinearInformative$.subscribe((item) => {
      this.controlLightInformative = item;
    });
    this.consensoService.privacyConsentsSubject.subscribe((data) => {
      this.personalDataIsValid = data.valid;
    });
    this.consensoService.genericConsentsSubject.subscribe((data) => {
      this.generalConditionIsValid = data.valid;
      this.checkboxClauseCondition = !data.data.clauseCondition;
      this.checkboxConsentCondition = !data.data.consentsCondition;
    });
  }

  public ngOnInit() {
    // SUBSCRIBE: Redirect if no opportunity ID in URL param
    this.opportunityId$
      .pipe(
        filter((id) => typeof id !== 'string' || (typeof id === 'string' && id.trim() === '')),
        takeUntil(this.ngUnsubscribe)
      )
      .subscribe((id) => {
        window.location.href = environment.websiteUrl;
      });
    // SUBSCRIBE: Fetch opportunity ID taken from URL param
    this.opportunityId$
      .pipe(
        filter((id) => typeof id === 'string' && id.trim() !== ''),
        takeUntil(this.ngUnsubscribe)
      )
      .subscribe((id) => {
        this.consensoService.fetchOpportunity(id);
      });
    // SUBSCRIBE: Keep instance copy of opportunity and approval ids
    this.consensoService.approval$.pipe(takeUntil(this.ngUnsubscribe)).subscribe((approval) => {
      this.approval = approval;
      this.needsPreConsent = !approval.otp_verified;
      this.productFamily = this.approval.product.family;
      this.isProductGasVulnerable =
        this.approval.vulnerabilityType !== VulnerabilityType.anagraficAge &&
        this.approval.vulnerabilityType !== undefined &&
        this.approval.product.family === 'ALG Vulnerabile Gas Domestico'
          ? true
          : false;
      this.isProductPlacet = this.approval.product.family.toLowerCase() === 'placet';
      this.vulnerabilityType = this.approval.vulnerabilityType;
      // Check vulnerabilityType and set vulnerabilityAcceptance properties
      this.vulnerabilityTypeUserSelected = this.approval.vulnerabilityType;
      if (this.approval.vulnerabilityType === VulnerabilityType.socialBonus) {
        this.vulnerabilityAcceptance.socialBonus = true;
        this.consensoService.vulnerabilityTypeUserSelected$.next(VulnerabilityType.socialBonus);
      } else if (this.approval.vulnerabilityType === VulnerabilityType.disability) {
        this.vulnerabilityAcceptance.disability = true;
        this.consensoService.vulnerabilityTypeUserSelected$.next(VulnerabilityType.disability);
      } else if (this.approval.vulnerabilityType === VulnerabilityType.housingEmergency) {
        this.vulnerabilityAcceptance.housingEmergency = true;
        this.consensoService.vulnerabilityTypeUserSelected$.next(VulnerabilityType.housingEmergency);
      }
      if (this.isProductGasVulnerable) {
        this.setUploaders(approval);
      }
      this.approvalId = !!approval && approval.id;
      this.opportunityId = !!approval && approval.opportunityId;
      this.phone_number = approval.phone;
      this.genFormControl(this.approval.product);
      this.isLinearGasOn = approval.Alg_GASInsurancePolicy__c;
      this.isLinearLightOn = approval.Alg_LIGHTInsurancePolicy__c;
      if (this.isLinearGasOn || this.isLinearLightOn) {
        this.currentStepStatus = 'options';
        this.firstStep = true;
      }
      this.config();
      const URL = `${environment.api.basePath}/upload-linear-documents/approval/${this.approvalId}`;

      this.uploaderFront = new FileUploader({
        url: URL,
        disableMultipart: false,
        itemAlias: 'linearDocumentFront',
        autoUpload: true,
      });
      this.uploaderFront.onBeforeUploadItem = (item) => {
        item.withCredentials = false;
      };

      this.uploaderBack = new FileUploader({
        url: URL,
        disableMultipart: false,
        itemAlias: 'linearDocumentBack',
        autoUpload: true,
      });
      this.uploaderBack.onBeforeUploadItem = (item) => {
        item.withCredentials = false;
      };
    });
    // SUBSCRIBE: Keep instance copy of consent validity status and consents object
    this.consensoService.isConsentsOk$
      .pipe(withLatestFrom(this.consensoService.privacyConsets$, this.consensoService.genericConsets$), takeUntil(this.ngUnsubscribe))
      .subscribe(([isconsentsOk, privacyConsents, genericConsents]) => {
        this.isConsentsOk = isconsentsOk;
        this.consents = {
          ...privacyConsents,
          ...genericConsents,
        };
      });
    // SUBSCRIBE: save and prepare policies links
    this.consensoService.policiesUrl$.pipe(takeUntil(this.ngUnsubscribe)).subscribe((policiesUrls) => {
      this.feedbackModalContent = {
        ...this.feedbackModalContent,
        description: `Effettuando la valutazione della chiamata esprimi il consenso al trattamento dei tuoi dati ai fini della valutazione della qualità del servizio. <a href="${policiesUrls.generalPolicy}" target="_blank">Info privacy</a>`,
      };
    });
    // SUBSCRIBE: scroll to top when approval status goes to APPROVAL_STATUS_COMPLETED
    this.isApprovalCompleted$
      .pipe(
        pairwise(),
        takeUntil(this.ngUnsubscribe),
        filter(([oldStatus, newStatus]) => !oldStatus && newStatus === true)
      )
      .subscribe(() => {
        if (window.scrollTo) {
          window.scrollTo(0, 0);
        }
      });
  }

  public ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  ngAfterContentChecked(): void {
    this.changeDetector.detectChanges();
  }

  private setUploaders(approval: Approval) {
    if (this.approval.webStatus == 'complete') return;
    const URL = `${environment.api.basePath}/upload-istanza-switch-in/${approval.feId}`;
    //upload istanza 1
    this.istanzaUploader1 = new FileUploader({
      url: URL,
      itemAlias: 'istanzaFilled1',
      autoUpload: true,
    });

    this.istanzaUploader1.onBeforeUploadItem = (file) => {
      const ext = file.file.name.split('.').pop();
      file.file.name = `${approval.opportunityId}_ist_1.${ext}`;
    };

    this.istanzaUploader1.onAfterAddingFile = (file) => {
      this.showProgress1 = true;
      file.withCredentials = false;
    };

    this.istanzaUploader1.onCompleteItem = (file, response) => {
      if (response) {
        const res = JSON.parse(response);
        this.approval.istanzaFilled1 = res.istanzaFilled1;
      }
      this.checkFileSize(this.approval.istanzaFilled1, 'istanzaFilled1');
    };

    //upload istanza 2
    this.istanzaUploader2 = new FileUploader({
      url: URL,
      itemAlias: 'istanzaFilled2',
      autoUpload: true,
    });

    this.istanzaUploader2.onBeforeUploadItem = (file) => {
      const ext = file.file.name.split('.').pop();
      file.file.name = `${approval.opportunityId}_ist_2.${ext}`;
    };

    this.istanzaUploader2.onAfterAddingFile = (file) => {
      this.showProgress2 = true;
      file.withCredentials = false;
    };

    this.istanzaUploader2.onCompleteItem = (file, response) => {
      if (response) {
        const res = JSON.parse(response);
        this.approval.istanzaFilled2 = res.istanzaFilled2;
      }
      this.checkFileSize(this.approval.istanzaFilled2, 'istanzaFilled2');
    };

    //upload istanza 3
    this.istanzaUploader3 = new FileUploader({
      url: URL,
      itemAlias: 'istanzaFilled3',
      autoUpload: true,
    });

    this.istanzaUploader3.onBeforeUploadItem = (file) => {
      const ext = file.file.name.split('.').pop();
      file.file.name = `${approval.opportunityId}_ist_3.${ext}`;
    };

    this.istanzaUploader3.onAfterAddingFile = (file) => {
      this.showProgress2 = true;
      file.withCredentials = false;
    };

    this.istanzaUploader3.onCompleteItem = (file, response) => {
      if (response) {
        const res = JSON.parse(response);
        this.approval.istanzaFilled3 = res.istanzaFilled3;
      }
      this.checkFileSize(this.approval.istanzaFilled3, 'istanzaFilled3');
    };

    //upload istanza 4
    this.istanzaUploader4 = new FileUploader({
      url: URL,
      itemAlias: 'istanzaFilled4',
      autoUpload: true,
    });

    this.istanzaUploader4.onBeforeUploadItem = (file) => {
      const ext = file.file.name.split('.').pop();
      file.file.name = `${approval.opportunityId}_ist_4.${ext}`;
    };

    this.istanzaUploader4.onAfterAddingFile = (file) => {
      this.showProgress2 = true;
      file.withCredentials = false;
    };

    this.istanzaUploader4.onCompleteItem = (file, response) => {
      if (response) {
        const res = JSON.parse(response);
        this.approval.istanzaFilled4 = res.istanzaFilled4;
      }
      this.checkFileSize(this.approval.istanzaFilled4, 'istanzaFilled4');
    };

    // upload idCard1
    this.idCardUploader1 = new FileUploader({
      url: URL,
      itemAlias: 'idCard1',
      autoUpload: true,
    });

    this.idCardUploader1.onBeforeUploadItem = (file) => {
      const ext = file.file.name.split('.').pop();
      file.file.name = `${approval.opportunityId}_CI_1.${ext}`;
    };

    this.idCardUploader1.onAfterAddingFile = (file) => {
      this.showProgress5 = true;
      file.withCredentials = false;
    };

    this.idCardUploader1.onCompleteItem = (file, response) => {
      if (response) {
        const res = JSON.parse(response);
        this.approval.idCard1 = res.idCard1;
      }
      this.checkFileSize(this.approval.idCard1, 'idCard1');
    };

    // upload idCard2
    this.idCardUploader2 = new FileUploader({
      url: URL,
      itemAlias: 'idCard2',
      autoUpload: true,
    });

    this.idCardUploader2.onBeforeUploadItem = (file) => {
      const ext = file.file.name.split('.').pop();
      file.file.name = `${approval.opportunityId}_CI_2.${ext}`;
    };

    this.idCardUploader2.onAfterAddingFile = (file) => {
      this.showProgress6 = true;
      file.withCredentials = false;
    };

    this.idCardUploader2.onCompleteItem = (file, response) => {
      if (response) {
        const res = JSON.parse(response);
        this.approval.idCard2 = res.idCard2;
      }
      this.checkFileSize(this.approval.idCard2, 'idCard2');
    };
  }

  public isEmptyObject(obj) {
    return obj && Object.keys(obj).length === 0;
  }

  public deleteFile(filelabel: string, filename: string) {
    const data = {
      id: this.approval.feId,
      file: filelabel,
      fileName: filename,
    };
    this.consensoService
      .deleteIstanza(data)
      .toPromise()
      .then((resp) => {
        if (resp.result.body === 'OK') {
          if (filelabel == 'istanzaFilled1') {
            this.showProgress1 = false;
          } else if (filelabel == 'istanzaFilled2') {
            this.showProgress2 = false;
            this.secondIstanza = false;
          } else if (filelabel == 'idCard1') {
            this.showProgress5 = false;
          } else if (filelabel == 'idCard2') {
            this.showProgress6 = false;
            this.idCardSecondIstanza = false;
          }
          this.consensoService[filelabel] = {};
        }
      });
  }

  public checkFileSize(obj: any, fileId: string) {
    if (obj.size > 25000000) {
      this.deleteFile(`${fileId}`, obj.filename);
      alert('File troppo grande. Max: 25MB');
    }
  }

  public downloadPdf(data) {
    var newBlob = new Blob([data], { type: 'application/pdf' });
    let url = window.URL.createObjectURL(newBlob);
    let pwa = window.open(url);
    if (!pwa || pwa.closed || typeof pwa.closed == 'undefined') {
      alert('Please disable your Pop-up blocker and try again.');
    }
  }

  public changeCheckbox(checkboxName: string) {
    switch (checkboxName) {
      case VulnerabilityType.socialBonus:
        this.vulnerabilityAcceptance.socialBonus = !this.vulnerabilityAcceptance.socialBonus;
        this.vulnerabilityAcceptance.disability = false;
        this.vulnerabilityAcceptance.housingEmergency = false;
        this.vulnerabilityTypeUserSelected = VulnerabilityType.socialBonus;
        this.api.vulnerabilityTypeUserSelected$.next(VulnerabilityType.socialBonus);
        break;
      case VulnerabilityType.disability:
        this.vulnerabilityAcceptance.socialBonus = false;
        this.vulnerabilityAcceptance.disability = !this.vulnerabilityAcceptance.disability;
        this.vulnerabilityAcceptance.housingEmergency = false;
        this.vulnerabilityTypeUserSelected = VulnerabilityType.disability;
        this.api.vulnerabilityTypeUserSelected$.next(VulnerabilityType.disability);
        break;
      case VulnerabilityType.housingEmergency:
        this.vulnerabilityAcceptance.socialBonus = false;
        this.vulnerabilityAcceptance.disability = false;
        this.vulnerabilityAcceptance.housingEmergency = !this.vulnerabilityAcceptance.housingEmergency;
        this.vulnerabilityTypeUserSelected = VulnerabilityType.housingEmergency;
        this.api.vulnerabilityTypeUserSelected$.next(VulnerabilityType.housingEmergency);
        break;
    }
  }

  public showVulnerabilityCheckboxes() {
    this.vulnerabilityCheckboxes = !this.vulnerabilityCheckboxes;
    this.downloadedPDF = true;
  }

  public nextStepUserVulnerable() {
    this.isProductGasVulnerableSecondStep = true;
  }

  public openModal(modalContent) {
    this.utils.disableOverflow();
    this.modalDialogService.openDialog(this.viewContainer, {
      title: modalContent.title,
      childComponent: AlgConditionModalComponent,
      settings: {
        closeButtonClass: 'close theme-icon-close',
        headerTitleClass: ' modal-title modal-title-underline',
      },
      data: {
        description: modalContent.description,
      },
    });
  }

  public readCondition(type) {
    let modalContent;
    if (type === 'dataConsent') {
      modalContent = this.feedbackModalContent;
    }
    this.openModal(modalContent || {});
  }

  // feedback
  public onFeebackModal(event) {
    if (event === 'open') {
      this.readCondition('dataConsent');
    }
  }

  public goToConsents() {
    if (!this.goNextStep) {
      if (!this.optionGasValue) {
        if (this.controlGasDeclare) {
          this.checkboxGasContainer.checkboxGasDeclare = true;
          if (this.product.type === ProductType.gas || this.product.type === ProductType.luceEgas) {
            this.scrollOnInvalidElement('gasInvalid');
          }
        }
        if (this.controlGasInformative) {
          this.checkboxGasContainer.checkboxGasInformative = true;
          if (this.product.type === ProductType.gas || this.product.type === ProductType.luceEgas) {
            this.scrollOnInvalidElement('gasInvalid');
          }
        }
      }
      if (!this.optionLightValue) {
        if (!this.controlLightDeclare) {
          this.checkboxLightContainer.checkboxLightDeclare = true;
          if (this.product.type === ProductType.luce || this.product.type === ProductType.luceEgas) {
            this.scrollOnInvalidElement('lightInvalid');
          }
        }
        if (!this.controlLightInformative) {
          this.checkboxLightContainer.checkboxLightInformative = true;
          if (this.product.type === ProductType.luce || this.product.type === ProductType.luceEgas) {
            this.scrollOnInvalidElement('lightInvalid');
          }
        }
      }
      return;
    }
    this.firstStep = false;
    this.currentStepStatus = 'consenso';
    if (!this.firstStep) {
      this.scrollOnTopElement('list-progress-id');
    }
    this.config();
  }

  private scrollOnTopElement(element) {
    document.getElementById(element).scrollIntoView({
      behavior: 'smooth',
      inline: 'nearest',
    });
  }

  private scrollOnInvalidElement(element) {
    document.getElementById(element).scrollIntoView({
      behavior: 'smooth',
      inline: 'nearest',
    });
  }

  private scrollOnInvalidChildComponent(element) {
    document.getElementById(element).scrollIntoView({
      behavior: 'smooth',
      block: 'end',
    });
  }

  getValidCheckboxes(value, type) {
    switch (type) {
      case 'gas':
        if (value === 'declare') {
          this.checkboxGasContainer.checkboxGasDeclare = false;
        }
        if (value === 'informative') {
          this.checkboxGasContainer.checkboxGasInformative = false;
        }
        break;

      case 'light':
        if (value === 'declare') {
          this.checkboxLightContainer.checkboxLightDeclare = false;
        }
        if (value === 'informative') {
          this.checkboxLightContainer.checkboxLightInformative = false;
        }
    }
  }

  getValidCheckboxesSecondPart(value, type) {
    switch (value) {
      case 'personal':
        this.checkboxPersonalData = false;
        break;

      case 'consents':
        if (type === 'clause') {
          this.checkboxGeneralCondition.checkboxClause = false;
        }
        if (type === 'consents') {
          this.checkboxGeneralCondition.checkboxConsents = false;
        }
    }
  }

  public openOTPmodal() {
    if (!this.isConsentsOk) {
      // Controls to make checkbox red
      if (!this.personalDataIsValid) {
        this.checkboxPersonalData = true;
        this.scrollOnInvalidElement('personalInvalid');
      }
      if (!this.generalConditionIsValid) {
        if (this.checkboxClauseCondition) {
          this.checkboxGeneralCondition.checkboxClause = true;
          this.scrollOnInvalidChildComponent('generalInvalid');
        }
        if (this.checkboxConsentCondition) {
          this.checkboxGeneralCondition.checkboxConsents = true;
          this.scrollOnInvalidElement('generalInvalid');
        }
      }
      return;
    }
    this.utils.disableOverflow();
    if (this.isConsentsOk) {
      this.consentsWithAdditionalProperty = {
        ...this.consents,
        cadastralCondition: true,
        cfgCondition: true,
        cteCondition: true,
        id: this.opportunityId,
      };
      if (this.product.family === 'Casa Agile' || this.product.family === 'Casa Agile Ecologica') {
        this.consentsWithAdditionalProperty = {
          ...this.consents,
          cadastralCondition: true,
          cfgCondition: true,
          cteCondition: true,
          id: this.opportunityId,
        };
      }
      if (this.optionGasValue) {
        this.consentsWithAdditionalProperty = {
          ...this.consents,
          Alg_GASInsurancePolicy__c: true,
          Alg_GASShowPolicy__c: true,
          Alg_LIGHTInsurancePolicy__c: false,
          Alg_LIGHTShowPolicy__c: false,
          informativeSetShowGas: true,
          informativeSetShowLight: false,
          Alg_LinearPhone__c: this.phone_number,
          id: this.opportunityId,
        };
      }
      if (this.optionLightValue) {
        this.consentsWithAdditionalProperty = {
          ...this.consents,
          Alg_GASInsurancePolicy__c: false,
          Alg_GASShowPolicy__c: false,
          Alg_LIGHTInsurancePolicy__c: true,
          Alg_LIGHTShowPolicy__c: true,
          Alg_LinearPhone__c: this.phone_number,
          informativeSetShowLight: true,
          informativeSetShowGas: false,
          id: this.opportunityId,
        };
      }
      if (this.optionLightValue && this.optionGasValue) {
        this.consentsWithAdditionalProperty = {
          ...this.consents,
          Alg_GASInsurancePolicy__c: true,
          Alg_GASShowPolicy__c: true,
          informativeSetShowGas: true,
          Alg_LIGHTInsurancePolicy__c: true,
          Alg_LIGHTShowPolicy__c: true,
          informativeSetShowLight: true,
          Alg_LinearPhone__c: this.phone_number,
          id: this.opportunityId,
        };
      }
      if (this.isProductGasVulnerable) {
        this.consentsWithAdditionalProperty = {
          ...this.consents,
          vulnerabilityTypeUserSelected: `${this.vulnerabilityTypeUserSelected}`,
          id: this.opportunityId,
        };
      }
      this.modalDialogService.openDialog(this.viewContainer, {
        title: 'Un ultimo passo: verifica il tuo numero di cellulare',
        childComponent: AlgOtpModalComponent,
        settings: {
          closeButtonClass: 'close theme-icon-close',
          headerTitleClass: 'modal-title modal-title-underline textCenter',
        },
        data: {
          isConsentsOk: this.isConsentsOk,
          consents: this.consentsWithAdditionalProperty,
          phone: this.phone_number,
          consensoType: true,
        },
      });
    }
  }

  // tslint:disable-next-line: use-life-cycle-interface
  ngOnChanges(changes: SimpleChanges) {
    this.allSteps.map((i) => {
      i.edited = false;
      if (i.stepName === changes.currentStatusFromStep.currentValue) {
        i.edited = true;
      }
    });
  }

  private config() {
    this.allSteps = [];
    this.currentStepFound = { status: false, number: 0 };

    Object.keys(this.onbProgressConfig).map((e) => {
      this.onbProgressConfig[e].stepName = e;
      this.allSteps.push(this.onbProgressConfig[e]);
    });
    this.allSteps.sort((a, b) => (a.stepNumber < b.stepNumber ? -1 : a.stepNumber > b.stepNumber ? 1 : 0));
    this.allSteps.map((e) => {
      e.edited = false;
      e.surpassed = true;
      e.consensoSurpassed = true;
      e.actual = false;
      if (e.stepName === this.currentStepStatus) {
        this.currentStepFound = { status: true, number: e.stepNumber };
        e.actual = true;
      }
      if (this.currentStepFound.status) {
        e.surpassed = false;
        e.consensoSurpassed = false;
      }
      return e;
    });
  }

  uploadDocument(type) {
    switch (type) {
      case 'front':
        (<HTMLInputElement>document.getElementById('frontDocument')).click();
        break;

      case 'back':
        (<HTMLInputElement>document.getElementById('backDocument')).click();
        break;
    }
  }

  private genFormControl(product: any) {
    this.product = product;

    if (product.type === ProductType.luce) {
      this.isLight = true;
      if (!this.isLinearLightOn) {
        this.firstStep = false;
        this.currentStepStatus = 'consenso';
      }
    }
    if (product.type === ProductType.gas) {
      this.isGas = true;
      if (!this.isLinearGasOn) {
        this.firstStep = false;
        this.currentStepStatus = 'consenso';
      }
    }
    if (product.type === ProductType.luceEgas) {
      this.isLight = true;
      this.isGas = true;
    }
  }

  droppedFile(event, type) {
    switch (type) {
      case 'front':
        this.documentUploadedFront = event[0].name;
        if (event[0].type === 'image/png' || event[0].type === 'image/jpeg' || event[0].type === 'image/jpg' || event[0].type === 'application/pdf') {
          this.uploadedDocumentFront = true;
          this.fileFormatErrorFront = false;
        } else {
          this.fileFormatErrorFront = true;
        }
        break;

      case 'back':
        this.documentUploadedBack = event[0].name;
        if (event[0].type === 'image/png' || event[0].type === 'image/jpeg' || event[0].type === 'image/jpg' || event[0].type === 'application/pdf') {
          this.uploadedDocumentBack = true;
          this.fileFormatErrorBack = false;
        } else {
          this.fileFormatErrorBack = true;
        }
        break;
    }
    this.goToNextStep();
  }

  selectedFile(event, type) {
    switch (type) {
      case 'front':
        this.documentUploadedFront = event[0].name;
        if (event[0].type === 'image/png' || event[0].type === 'image/jpeg' || event[0].type === 'image/jpg' || event[0].type === 'application/pdf') {
          this.uploadedDocumentFront = true;
        }
        break;

      case 'back':
        this.documentUploadedBack = event[0].name;
        if (event[0].type === 'image/png' || event[0].type === 'image/jpeg' || event[0].type === 'image/jpg' || event[0].type === 'application/pdf') {
          this.uploadedDocumentBack = true;
        }
        break;
    }
    this.goToNextStep();
  }

  getOptionChoices(event, type) {
    switch (type) {
      case 'gas':
        this.optionGasValue = event;
        break;

      case 'light':
        this.optionLightValue = event;
        break;
    }
    this.goToNextStep();
  }

  getInformative(value, type) {
    switch (type) {
      case 'gas':
        this.informativeGasBeenReaded = value;
        break;

      case 'light':
        this.informativeLightBeenReaded = value;
        break;
    }
  }

  sendTypeStatus(type) {
    if (this.onbProgressConfig[this.currentStepStatus].stepNumber < type.stepNumber) {
      return;
    }
    if (type.stepName === 'options') {
      this.firstStep = true;
    }
    if (type.stepName === 'consenso' && this.firstStep === true) {
      this.firstStep = false;
      this.allSteps.map((e) => {
        if (e.stepNumber !== type.stepNumber) {
          e.consensoSurpassed = true;
        }
      });
    }
    this.allSteps.map((e) => {
      e.edited = false;
      if (e.stepNumber === type.stepNumber && this.onbProgressConfig[this.currentStepStatus].stepNumber !== type.stepNumber) {
        e.edited = true;
        e.consensoSurpassed = false;
      }
    });
  }

  goToNextStep() {
    if (this.product.type === ProductType.luce) {
      if (this.optionLightValue && this.uploadedDocumentFront && this.uploadedDocumentBack) {
        this.goNextStep = true;
      } else {
        this.goNextStep = false;
      }
    }
    if (this.product.type === ProductType.gas) {
      if (this.optionGasValue && this.uploadedDocumentFront && this.uploadedDocumentBack) {
        this.goNextStep = true;
      } else {
        this.goNextStep = false;
      }
    }
    if (this.product.type === ProductType.luceEgas && this.uploadedDocumentFront && this.uploadedDocumentBack) {
      if (!this.isLinearLightOn) {
        if (this.isLinearGasOn && this.optionGasValue) {
          this.goNextStep = true;
        } else {
          this.goNextStep = false;
        }
      }
      if (!this.isLinearGasOn) {
        if (this.isLinearLightOn && this.optionLightValue) {
          this.goNextStep = true;
        } else {
          this.goNextStep = false;
        }
      }
      if (this.isLinearGasOn && this.isLinearLightOn) {
        if (this.optionGasValue && this.optionLightValue) {
          this.goNextStep = true;
        } else {
          this.goNextStep = false;
        }
      }
    }
  }

  fileOverBase(event, type) {
    switch (type) {
      case 'front':
        this.overDropFront = event;
        break;
      case 'back':
        this.overDropBack = event;
    }
  }

  handlePreConsentClick() {
    this.needsPreConsent = false;
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/alg-consenso/alg-consenso.component.ts